import { render, staticRenderFns } from "./Showcase.vue?vue&type=template&id=0deab386&scoped=true"
import script from "./Showcase.vue?vue&type=script&lang=js"
export * from "./Showcase.vue?vue&type=script&lang=js"
import style0 from "./Showcase.vue?vue&type=style&index=0&id=0deab386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deab386",
  null
  
)

export default component.exports